import { memo } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { TextAreaField } from "@/components/ui/form/fields/text-area-field";

import { useCampaignDescription } from "./hooks";

export const QuestionDescription = memo(() => {
	const { description, onSetDescription } = useCampaignDescription();

	return (
		<QuestionForMain
			required={true}
			title="キャンペーンの紹介文(ゲスト用)"
			guide="キャンペーンの内容をゲストに伝える紹介文を書きましょう。"
			inputChildren={
				<TextAreaField
					errorMessage={description?.error}
					value={description?.value ?? undefined}
					handleChange={onSetDescription}
				/>
			}
		/>
	);
});

QuestionDescription.displayName = "QuestionDescription";
